<!-- Component template used directly as modal content -->
<div class="modal-centered" style="width:100%;">
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h5 class="modal-title fw-semibold mb-0">CV Progress</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="isWorking"></button>
    </div>
    <div class="modal-body px-4 py-4">

        <div *ngIf="isPending()" class="mb-4">
          <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">Upload CV</label>
          <input #initialFileInput type="file" accept="application/pdf,.doc,.docx" class="d-none"
            (change)="onFileSelected($event)" />
          <div class="border border-2 border-dashed rounded p-4 text-center bg-light position-relative"
            style="min-height: 140px;" (dragover)="allowDragOver($event)" (drop)="onFileDropped($event)">
            <ng-container *ngIf="!submissionFile">
              <i class="fe fe-upload text-muted mb-2" style="font-size: 32px;"></i>
              <p class="mb-3 text-muted" style="font-size: 14px;">Drag & drop the candidate's CV here</p>
              <button type="button" class="btn btn-primary btn-sm" (click)="initialFileInput.click()">
                <i class="fe fe-folder me-1"></i> Browse Files
              </button>
            </ng-container>
            <ng-container *ngIf="submissionFile">
              <i class="fe fe-file-text text-success mb-2" style="font-size: 32px;"></i>
              <p class="mb-2 fw-semibold" style="font-size: 14px;">{{ submissionFile?.name }}</p>
              <p class="text-success mb-3" style="font-size: 12px;">✓ Ready to submit</p>
              <button type="button" class="btn btn-primary btn-sm" (click)="initialFileInput.click()">
                <i class="fe fe-folder me-1"></i> Change File
              </button>
            </ng-container>
          </div>
        </div>

        <div *ngIf="isCompleted()">
          <div class="mb-4">
            <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">Initial Submission</label>
            <div *ngIf="getSubmissionLink()"
              class="d-flex align-items-center justify-content-between border rounded p-3 bg-white">
              <div class="d-flex align-items-center">
                <i class="fe fe-file-text me-2 text-primary" style="font-size: 20px;"></i>
                <span style="font-size: 14px; font-weight: 500;">Original CV</span>
              </div>
              <button class="btn btn-sm btn-primary" (click)="viewSubmission()" style="font-size: 13px;">
                <i class="fe fe-eye me-1"></i> View
              </button>
            </div>
            <div *ngIf="!getSubmissionLink()" class="text-muted text-center py-3 border rounded bg-light"
              style="font-size: 13px;">
              No initial CV submission found
            </div>
          </div>

          <div *ngIf="getUpdatedSubmissionLink()" class="mb-4">
            <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">Deliverable</label>
            <div class="d-flex align-items-center justify-content-between border rounded p-3 bg-white">
              <div class="d-flex align-items-center">
                <i class="fe fe-file-text me-2 text-success" style="font-size: 20px;"></i>
                <span style="font-size: 14px; font-weight: 500;">Revised CV</span>
              </div>
              <button class="btn btn-sm btn-primary" (click)="viewUpdatedSubmission()" style="font-size: 13px;">
                <i class="fe fe-eye me-1"></i> View
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="!isPending() && !isCompleted()">
          <div class="mb-4">
            <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">Initial Submission</label>
            <div *ngIf="getSubmissionLink()"
              class="d-flex align-items-center justify-content-between border rounded p-3 bg-white">
              <div class="d-flex align-items-center">
                <i class="fe fe-file-text me-2 text-primary" style="font-size: 20px;"></i>
                <span style="font-size: 14px; font-weight: 500;">Original CV</span>
              </div>
              <button class="btn btn-sm btn-outline-primary" (click)="viewSubmission()" style="font-size: 13px;">
                <i class="fe fe-eye me-1"></i> View
              </button>
            </div>
            <div *ngIf="!getSubmissionLink()" class="text-muted text-center py-3 border rounded bg-light"
              style="font-size: 13px;">
              No initial CV submission found
            </div>
          </div>
        </div>

        <!-- Deliverable upload: Received or In progress → Complete -->
        <div *ngIf="canUploadDeliverable()" class="mb-4">
          <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">
            Upload revised CV (completes this request)
          </label>
          <input #updatedFileInput type="file" accept="application/pdf,.doc,.docx" class="d-none"
            (change)="onUpdatedCvSelected($event)" />

          <div *ngIf="!updatedCvFile && getUpdatedSubmissionLink()"
            class="border border-2 border-dashed rounded p-4 text-center bg-light position-relative"
            style="min-height: 140px;" (dragover)="allowDragOver($event)" (drop)="onUpdatedCvDropped($event)">
            <i class="fe fe-file-text text-info mb-2" style="font-size: 32px;"></i>
            <p class="mb-2 fw-semibold text-info" style="font-size: 14px;">Current: Revised CV</p>
            <div class="gap-2 ">
              <button type="button" class="btn btn-outline-primary btn-sm mb-2" (click)="viewUpdatedSubmission()">
                <i class="fe fe-eye me-1"></i> View Current
              </button>
            </div>
            <button type="button" class="btn btn-primary btn-sm" (click)="updatedFileInput.click()">
              <i class="fe fe-folder me-1"></i> Replace File
            </button>
          </div>

          <div *ngIf="!updatedCvFile && !getUpdatedSubmissionLink()"
            class="border border-2 border-dashed rounded p-4 text-center bg-light position-relative"
            style="min-height: 140px;" (dragover)="allowDragOver($event)" (drop)="onUpdatedCvDropped($event)">
            <i class="fe fe-upload text-muted mb-2" style="font-size: 32px;"></i>
            <p class="mb-3 text-muted" style="font-size: 14px;">Drag & drop the revised CV here to complete</p>
            <button type="button" class="btn btn-primary btn-sm" (click)="updatedFileInput.click()">
              <i class="fe fe-folder me-1"></i> Browse Files
            </button>
          </div>

          <div *ngIf="updatedCvFile"
            class="border border-2 border-dashed rounded p-4 text-center bg-light position-relative"
            style="min-height: 140px;" (dragover)="allowDragOver($event)" (drop)="onUpdatedCvDropped($event)">
            <i class="fe fe-file-text text-success mb-2" style="font-size: 32px;"></i>
            <p class="mb-2 fw-semibold" style="font-size: 14px;">{{ updatedCvFile?.name }}</p>
            <p class="text-success mb-3" style="font-size: 12px;">✓ Ready — will mark Completed</p>
            <button type="button" class="btn btn-primary btn-sm" (click)="updatedFileInput.click()">
              <i class="fe fe-folder me-1"></i> Change File
            </button>
          </div>
        </div>

        <div class="mb-4">
          <label class="form-label text-dark mb-2" style="font-size: 14px; font-weight: 500;">Current Status</label>
          <div class="d-flex align-items-center">
            <span class="px-3 py-2 rounded bg-light text-dark" style="font-size: 14px; font-weight: 500;">
              {{ selectedCv?.status | cvStatusPipe }}
            </span>
          </div>
        </div>

        <div *ngIf="isReceived()" class="alert alert-info border-0 py-2 mb-0" style="font-size: 13px;">
          <i class="fe fe-info me-2"></i>
          Upload the revised CV to complete, or start work to mark this request in progress.
        </div>
        <div *ngIf="isInProgress()" class="alert alert-info border-0 py-2 mb-0" style="font-size: 13px;">
          <i class="fe fe-info me-2"></i>
          Upload the revised CV to complete this request.
        </div>
        <div *ngIf="isCompleted() && !isLegacyReviewed()" class="alert alert-success border-0 py-2 mb-0" style="font-size: 13px;">
          <i class="fe fe-check-circle me-2"></i>CV request completed
        </div>

    </div>
    <div class="modal-footer border-top" *ngIf="!isCompleted() || isLegacyReviewed()">
      <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isWorking"
        style="font-size: 14px;">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="proceed()"
        [disabled]="!canProceed() || isWorking || (isInProgress() && !updatedCvFile)"
        style="font-size: 14px;">
        <span *ngIf="isWorking" class="spinner-border spinner-border-sm me-2"></span>
        <span>{{ isWorking ? 'Processing...' : proceedButtonLabel() }}</span>
      </button>
    </div>
  </div>
</div>
